import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { useMessageUnreadStore } from '@/features/messages/messageUnreadStore';

/** Keep the app-shell Messages badge populated even when chat is not open. */
export function useMessageUnreadCount(): number {
  const userId = useAuthStore((state) => state.user?.id);
  const count = useMessageUnreadStore((state) => state.count);
  const resetUnread = useMessageUnreadStore((state) => state.reset);

  useEffect(() => {
    if (!userId) {
      resetUnread();
    }
  }, [resetUnread, userId]);

  return count;
}
